<template lang="pug">
    div.select-option-button-control(@click="click" ref="button")
        svg-icon(iconId="options-circle")
</template>

<script>
import eventBus from '../../lib/event-bus'
import events from '../../lib/events'
import modalsList from '../modals/modals-list'

export default {
    name: 'select-option-button-control',
    props: {
        options: {
            type: Array,
            required: true,
        },
    },
    methods: {
        click() {
            eventBus.$emit(events.OPEN_MODAL, modalsList.SELECT_OPTION, {
                element: this.$refs.button,
                options: this.options,
                handler: this.selectOption,
            })
        },
        selectOption(option) {
            this.$emit('select', option)
        },
    },
}
</script>
